module.exports = __webpack_public_path__ + "static/media/donation-banner-bg.df35315e.jpg";